<template>
  <v-container fluid>
      <div class='font-weight-bold'>Payroll Deduct</div>
      <v-row>
        <v-col cols="12">
            <p>I authorize my employer to deduct Local, MEA and NEA dues, assessments and contributions as may be determined from time to time, unless I revoke this authorization in writing as described in the <v-btn plain class="blue--text text--darken-3 px-0" dense @click="show_main_terms=true;"> terms and conditions</v-btn></p>
        </v-col>
      </v-row>
      <terms-and-conditions-dialog :showDialog="show_main_terms" :termsDetails="$store.getters.getMainTerms" @close-dialog="show_main_terms=false"></terms-and-conditions-dialog>
  </v-container>
</template>

<script>
import TermsAndConditionsDialog from '../DialogComponents/TermsAndConditionsDialog.vue'
  //import axios from 'axios'
  export default {
    name: 'LblPayrollDeduct',
    components:
    {
        TermsAndConditionsDialog
    },
    data:() => ({        
        show_main_terms:false
    }),
    methods:{        
    },
    mounted:function(){

    },
    watch:{        
    }
  }
</script>

<style scoped>
</style>